import React, { useState } from "react";
import {Grid,
    Tabs,
    Tab,
    Box,
    Typography,
    TextField,
    Button,
    Avatar,
    Stack,
    Divider,
    Paper,
    Alert,
} from "@mui/material";
import { LockOutlined, Person } from "@mui/icons-material";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";
import { userSelector } from "../../Components/user-redux/selector";
import Key from "../../clientVariables.json";
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';

const Adminsettings = () => {
    const { user } = useSelector(userSelector);
    const [activeTab, setActiveTab] = useState(0);
    const [formState, setFormState] = useState({
        fullName: user.full_name || "",
        email: user.username || "",
        mobile: user.phone || "",
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
        companyName: "", // New field for company
        companyAddress: "", // New field for company address
    });

    const [errors, setErrors] = useState({
        newPassword: false,
        confirmPassword: false,
    });
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    // Handle Tab Change
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // Handle Input Changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormState((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Placeholder handlers for form submissions
    const handleUserDetailsSubmit = (event) => {
        event.preventDefault();
        alert("User Details Submitted!");
    };

    const handleChangePasswordSubmit = async (event) => {
        event.preventDefault();
        const { currentPassword, newPassword, confirmPassword } = formState;
        if (newPassword !== confirmPassword) {
            setError("New passwords do not match.");
            return;
        }

        const response = await fetch(`${Key.domain}/common/update_password`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                username: user?.username,
                password: newPassword,
                currentPassword: currentPassword,
            }),
        });

        const result = await response.json();
        if (response.ok && result.success === 1) {
            setSuccess("Password changed successfully!");
            setError("");
            window.location.reload();
        } else if (response.ok && result.success === 0) {
            setError(result.message || "Your Current Password is Incorrect");
        } else {
            setError(result.message || "Failed to change password.");
        }
    };

    const handleCompanyDetailsSubmit = (event) => {
        event.preventDefault();
        alert("Company Details Submitted!");
    };

    return (
        <Box sx={{ maxWidth: 688, margin: "50px auto", p: 1 }}>
            <Paper elevation={2} style={{ padding: "20px" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    centered
                    sx={{ mb: 2,}}
                    variant="fullWidth"
                >
                    <Tab
                        label="User Details"
                        icon={<Person />}
                        iconPosition="start"
                        sx={{ textTransform: "none" }}
                    />
                    <Tab
                        label="Company Details"
                        icon={<AccountBalanceOutlinedIcon />}
                        iconPosition="start"
                        sx={{ textTransform: "none" }}
                    />
                    <Tab
                        label="Change Password"
                        icon={<LockOutlined />}
                        iconPosition="start"
                        sx={{ textTransform: "none" }}
                    />
                </Tabs>

                {/* User Details Tab */}
                {activeTab === 0 && (
                    <Box component="form" onSubmit={handleUserDetailsSubmit}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            <Avatar alt="User Profile" sx={{ width: 80, height: 80 }} />
                            <Button variant="outlined" component="label">
                                Upload Profile
                                <input hidden accept="image/*" type="file" />
                            </Button>
                        </Stack>

                        <Divider sx={{ my: 2 }} />
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Full Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    required
                                    name="fullName"
                                    value={formState.fullName}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Mobile"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    required
                                    type="tel"
                                    name="mobile"
                                    value={formState.mobile}
                                    onChange={handleInputChange}
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    disabled
                                    fullWidth
                                    margin="normal"
                                    required
                                    type="email"
                                    name="email"
                                    value={formState.email}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                           
                        </Grid>

                        

                        <Box sx={{ mt: 2 }}>
                            <Button type="submit" variant="contained" color="primary" sx={{textTransform:"none"}}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                )}

                {/* Company Details Tab */}
                {activeTab === 1 && (
                    <Box component="form" onSubmit={handleCompanyDetailsSubmit}>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            {/* First Column */}
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Company Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    required
                                    name="companyName"
                                    value={formState.companyName}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Company URL"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="companyURL"
                                    value={formState.companyURL}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Contact Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="contactName"
                                    value={formState.contactName}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Contact Email"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    type="email"
                                    name="contactEmail"
                                    value={formState.contactEmail}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Contact Number"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="contactNumber"
                                    value={formState.contactNumber}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Since"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="since"
                                    value={formState.since}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                           
                           
                       
                            
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    label="Address"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="address"
                                    value={formState.address}
                                    onChange={handleInputChange}
                                    multiline
                                    rows={4} // Specify the number of rows for the text area
                                />

                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Country"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="country"
                                    value={formState.country}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="State"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="state"
                                    value={formState.state}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="City"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="city"
                                    value={formState.city}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                          
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Zipcode"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="zipcode"
                                    value={formState.zipcode}
                                    onChange={handleInputChange}
                                />
                            </Grid>


                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Company Fax"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="companyFax"
                                    value={formState.companyFax}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="EIN/SSN"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="einSsn"
                                    value={formState.einSsn}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Size"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="size"
                                    value={formState.size}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="State of Incorporation"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name="stateOfIncorporation"
                                    value={formState.stateOfIncorporation}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <ReactQuill
                                    value={formState.description}
                                    onChange={handleInputChange}
                                    // onFocus={() => setEditorFocused(true)}
                                    modules={{
                                        toolbar: [
                                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                            ["bold", "italic", "underline", "strike", "blockquote"],
                                            [{ color: [] }, { background: [] }],
                                            [{ align: [] }],
                                            [{ list: "ordered" }, { list: "bullet" }],
                                            ["code-block"],
                                            ["link", "image", "video"],
                                            ["clean"],
                                        ],
                                    }}
                                    placeholder="Enter your message..."
                                     style={{ height: "150px" }}
                                    id="jobDescription"
                                />
                              
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 12 }}>
                            <Button type="submit" variant="contained" color="primary" sx={{ textTransform: "none" }}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                )}

                {/* Change Password Tab */}
                {activeTab === 2 && (
                    <Box component="form" onSubmit={handleChangePasswordSubmit}>
                        {error && <Alert severity="error">{error}</Alert>}
                        {success && <Alert severity="success">{success}</Alert>}
                        <TextField
                            label="Current Password"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            required
                            type="password"
                            name="currentPassword"
                            value={formState.currentPassword}
                            onChange={handleInputChange}
                        />
                        <TextField
                            label="New Password"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            required
                            type="password"
                            name="newPassword"
                            value={formState.newPassword}
                            onChange={handleInputChange}
                        />
                        <TextField
                            label="Confirm New Password"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            required
                            type="password"
                            name="confirmPassword"
                            value={formState.confirmPassword}
                            onChange={handleInputChange}
                        />

                        <Box sx={{ mt: 2 }}>
                            <Button type="submit" variant="contained" color="primary" sx={{textTransform:"none"}} >
                                Change Password
                            </Button>
                        </Box>
                    </Box>
                )}
            </Paper>
        </Box>
    );
};

export default Adminsettings;
